import { render, staticRenderFns } from "./Discovery.vue?vue&type=template&id=c6808888&"
import script from "./Discovery.vue?vue&type=script&lang=js&"
export * from "./Discovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/jeffreymb/BibleLing/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6808888')) {
      api.createRecord('c6808888', component.options)
    } else {
      api.reload('c6808888', component.options)
    }
    module.hot.accept("./Discovery.vue?vue&type=template&id=c6808888&", function () {
      api.rerender('c6808888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Discovery.vue"
export default component.exports